var React = require('react');

function Verified (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m21.8 30.65 11.4-11.4-2.1-2.05-9.15 9.15-5.05-5.05-2.2 2.2Zm2.2 13.3q-7-1.75-11.5-8.125T8 21.85V9.95l16-6 16 6v11.9q0 7.6-4.5 13.975T24 43.95Zm0-3.1q5.75-1.9 9.375-7.175T37 21.85v-9.8l-13-4.9-13 4.9v9.8q0 6.55 3.625 11.825Q18.25 38.95 24 40.85ZM24 24Z"}));
}

Verified.defaultProps = {"height":"48","width":"48"};

module.exports = Verified;

Verified.default = Verified;
